import { Formik, Form } from 'formik'
import { GeneralSetting } from '@apis'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import SettingCard from '../settingCard'
import { StyleFormGrid } from './style'
import Fields from '@components/fields'

const Logos = () => {
  const { data: logos } = useSelector((state: any) => state.logos)
  const initial = {
    footerLogo: '',
    headerLogo: '',
    favicon: '',
  }
  const [initialValues, setInitialValues] = useState(initial)
  const submitHandler = async (payload: any) => {
    const logo = logos?.find((logo) => logo.key == payload.key)
    if (logo?.id) {
      await GeneralSetting.update({
        data: payload,
        state: 'logos',
        id: logo?.id,
      }).catch(() => {})
    } else {
      await GeneralSetting.create({
        data: payload,
        state: 'logos',
      }).catch(() => {})
    }
  }

  const fetchData = async () => {
    await GeneralSetting.getByGroup({
      id: 'logos',
      state: 'logos',
    }).catch(() => {})
  }
  useEffect(() => {
    if (logos?.length) {
      const headerLogo = logos?.find((logo) => logo.key == 'header-logo')
      const footerLogo = logos?.find((logo) => logo.key == 'footer-logo')
      const favicon = logos?.find((logo) => logo.key == 'favicon')

      setInitialValues({
        footerLogo: footerLogo?.file || '',
        headerLogo: headerLogo?.file || '',
        favicon: favicon?.file || '',
      })
    } else {
      setInitialValues(initial)
    }
  }, [logos?.length])

  useEffect(() => {
    if (!logos?.length) {
      fetchData()
    }
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      {() => {
        return (
          <Form>
            <StyleFormGrid>
              <SettingCard title="Header Logo">
                <Fields.Upload
                  varient="drag"
                  name="headerLogo"
                  icon={'squareGallery'}
                  placeholder="Browse Image"
                  size={200}
                  onChange={(file) => {
                    submitHandler({
                      title: 'Header Logo',
                      key: 'header-logo',
                      group: 'logos',
                      value: 'Header Logo',
                      file: {
                        base64: file?.base64,
                        extension: file?.extension,
                      },
                    })
                  }}
                />
              </SettingCard>
              <SettingCard title="Footer Logo">
                <Fields.Upload
                  varient="drag"
                  name="footerLogo"
                  icon={'squareGallery'}
                  size={200}
                  placeholder="Browse Image"
                  onChange={(file) => {
                    submitHandler({
                      title: 'Footer Logo',
                      key: 'footer-logo',
                      group: 'logos',
                      value: 'Footer Logo',
                      file: {
                        base64: file?.base64,
                        extension: file?.extension,
                      },
                    })
                  }}
                />
              </SettingCard>
              <SettingCard title="Fav Icon">
                <Fields.Upload
                  varient="drag"
                  name="favicon"
                  size={200}
                  icon={'squareGallery'}
                  placeholder="Browse Image"
                  onChange={(file) => {
                    submitHandler({
                      title: 'Favicon',
                      key: 'favicon',
                      group: 'logos',
                      value: 'Favicon',
                      file: {
                        base64: file?.base64,
                        extension: file?.extension,
                      },
                    })
                  }}
                />
              </SettingCard>
            </StyleFormGrid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Logos
